import useKlydoMutation from "../../../../components/hooks/useKlydoMutation";
import uploadsApiClient, { UploadFileInput } from "../../../../api/uploads";

interface UseFileUploadMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useFileUploadMutation = (options?: UseFileUploadMutationOptions) => {
  return useKlydoMutation({
    mutationFn: (input: UploadFileInput) =>
      uploadsApiClient.uploadPendulumLogo(input),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};

export default useFileUploadMutation;
